import { SelectedMenu, SelectedMenuProductList } from 'rangeConfig/@types';
import { matchWidth } from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import { requiresSelectedColour } from 'rangeConfig/boaxel/filters/selectedMenuProductFilters';

const selectedMenuInterior: SelectedMenuProductList = {
  id: 'interior-selected-menu-interior',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [replaceProduct],
    productDropped: [replaceProduct]
  },
  productTypes: [],
  productFilters: [requiresSelectedColour, matchWidth]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseInterior',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: [selectedMenuInterior]
};

export default selectedMenu;
